import { Member } from '@/types'
import { isBillableRole } from '@/utils/role'
import { isMemberOnTrial } from '@/utils/subscription'

// Buckets are mutually exclusive and exhaustive over the members list.
// IT admins are "always free" — their trial state is ignored, so a trialing
// IT admin lands in `itAdmin`, not `trialing`.
export interface MemberBuckets {
  paid: number
  trialing: number
  itAdmin: number
}

export const bucketMembers = (members: Member[]): MemberBuckets => {
  let paid = 0
  let trialing = 0
  let itAdmin = 0
  for (const m of members) {
    if (m.role === 'it_admin') {
      itAdmin += 1
    } else if (isBillableRole(m.role) && isMemberOnTrial(m.trialEndsAt)) {
      trialing += 1
    } else if (isBillableRole(m.role)) {
      paid += 1
    }
  }
  return { paid, trialing, itAdmin }
}
